import { userAccessLevel } from '../../user';
import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertLevel, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class ActuatorContinuallyTurning extends AlertLogic {
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.EQUIPMENT_FAILURE ];
    static title = Locale.gettext('Actuator Continually Turning');
    static type:AlertType|AlertType[] = AlertType.ActuatorContinuallyTurning;

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;

        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);

        const detailDescription4 =
        config?.Config?.Settings?.IgnoreActuatorErrorsAndTurnOnPumps
            ? undefined
            : this.locale.gettext('Pumps will not run until this is addressed.')
        ;
        const detailDescription5 =
            config?.Config?.FreezeProtect.Mode !== Config.FreezeProtectModes.DISABLED
            ? this.locale.gettext('Please note that this alert is ignored when Freeze Protect is running.')
            : undefined
        ;
        
        // Varying across alert types
        let actionTitle = '';
        let action:any = false;
        if (device.UUID) {
            actionTitle = this.locale.gettext('Recalibrate');
            action = {
                actions: [
                    {
                        type: 'confirm'
                    },
                    {
                        type: 'directMethodCall',
                        deviceUuid: config.Config.Controllers.find(dev => dev.Number === 1).UUID,
                        method: 'Device.calibrateActuators',
                        params: {
                            ActuatorUUID: device.UUID
                        }
                    }
                ],
                successConfirm: this.locale.gettext('Recalibration started'),
                closeAfter: true
            };
        }
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Malfunctioning Actuator'),
            cardDescription: this.locale.gettext('%1$s is continually turning', device.Name),
            cardIllustration: 'pipes_emergency',
            detailIcon: 'actuator3',
            detailDescription: this.locale.gettext('We detected actuator "%3$s" on port %1$s is continually turning starting %2$s.', 
                device.HardwareDevice?.Ports[0]?.Number,
                this.locale.formatTimeHumanFriendy(alert.created, undefined, undefined, true, timeZone),
                device.Name
            ),
            detailDescription2: this.locale.gettext('The motor has slipped a gear, has an incorrect cam, the wire to the actuator has shorted, or the calibration is incorrect.'),
            detailDescription3: this.locale.gettext('If you are sure that the actuator is not broken, try recalibrating it.'),
            detailDescription4,
            detailDescription5,
            actionButtonTitle: actionTitle || false,
            actionButtonAction: action,
            actionButtonVisibleFor: userAccessLevel.SharedFullAccess,
            actionButtonEnabledFor: userAccessLevel.SharedAdminAccess,
            resolveSummary: this.locale.gettext('%1$s is back to normal', device.Name)
        });
        alertInfo.contentCategories = ActuatorContinuallyTurning.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device:Partial<Config.DeviceConfig> = 
                        config?.Config?.Devices?.find(dev => dev.DeviceType === "ActuatorThreeWay") || 
                        config?.Config?.Devices?.find(dev => dev.DeviceType === "ActuatorTwoWay");
        device = device;

        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type.toString().replace('ACTUATOR_', '')),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config?.Config?.BodiesOfWater[0]?.UUID,
            level: AlertLevel.Error,
            type: type,
            data: {
                
            }
        }) : null;
    }
}